import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/landing";
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1;
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 top-3 z-50 flex justify-center sm:inset-x-auto sm:bottom-5 sm:left-5 sm:top-auto sm:justify-start" aria-live="polite" data-id="element-274" data-mp="117ft09vkm7v1">
      <AnimatePresence data-id="element-275" data-mp="1awpidhz15cfg">
        {notice && !dismissed && <motion.div key={notice.name + notice.minutes} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 text-navy-900 shadow-2xl ring-1 ring-navy-900/10" style={{
        position: "relative"
      }} data-id="element-276" data-mp="1ax7n72zrcyyz">
            <img src={images.product} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-277" data-mp="28mapq17wtfzs" />
            <div className="min-w-0" data-id="element-278" data-mp="2aol5sgud8i4u">
              <p className="text-sm font-bold leading-tight" data-id="element-279" data-mp="2anjkljjmyf9e">
                {notice.name} <span className="font-medium text-navy-700" data-id="element-280" data-mp="2fn4sijgs9xy9">from {notice.country}</span>
              </p>
              <p className="mt-0.5 text-sm leading-tight text-navy-700" data-id="element-281" data-mp="2kmhfr5bkh71d">just purchased Denture Blueprint™</p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-emerald-700" data-id="element-282" data-mp="2pksplg1v3hjl">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-283" data-mp="1rz4sesxl0v70" /> Verified · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-navy-600 hover:bg-navy-900/5" data-id="element-284" data-mp="1wv260rhgnng3">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-285" data-mp="196j3ksl3e4vx" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}